import Project from '@/components/whiteboard/project';
import paper from 'paper';

export default class Node {
    layer;
    group;
    path;
    circles;

    constructor(layer, paperItem) {
        this.layer = layer;
        this.layer.nodes.push(this);

        if (paperItem === undefined) {
            this.createPaperItem();
        } else if (typeof paperItem === 'object' && paperItem[0] === 'Group') {
            this.group = paper.project.activeLayer.importJSON(paperItem);
            this.path = this.group.children[0];
            this.circles = this.group.children[1];
        } else {
            // paperItem contains coordinates array;
            this.createPaperItem(paperItem);
        }

        this.enrichPaperItem();
    }

    createPaperItem(coordinates) {
        let point;
        let size;

        if (coordinates) {
            point= new paper.Point(coordinates[0], coordinates[1])
            size = new paper.Size(0, 0);
        } else {
            point= new paper.Point(20, 20);
            size = new paper.Size(50, 70);
        }

        this.group = new paper.Group();
        this.group.data.type = 'node';

        let rect = new paper.Rectangle(point, size);
        this.path = new paper.Path.Rectangle(rect);

        this.path.strokeColor = '#000000';
        this.path.fillColor = '#ffffff';

        this.group.addChild(this.path);

        this.circles = new paper.Group();
        this.group.addChild(this.circles);

        for (let i = 0; i < this.path.segments.length; i++) {
            let circle = new paper.Path.Circle({
                center: this.path.segments[i].point,
                fillColor: '#ff0000',
                radius: 4
            });

            this.circles.addChild(circle);
        }
    }

    enrichPaperItem() {
        this.group.onMouseDrag = this.onDrag.bind(this);
        this.group.onMouseDown = this.onDown.bind(this);
        this.group.onMouseUp = this.onUp.bind(this);

        for (let i = 0; i < this.circles.children.length; i++) {
            this.circles.children[i].onMouseDrag = this.onCircleDrag.bind(this);
        }
    }

    moveCorner(cornerIndex, x, y) {
        this.path.segments[cornerIndex].point.x += x;
        this.path.segments[cornerIndex].point.y += y;

        this.circles.children[cornerIndex].position = this.path.segments[cornerIndex].point;

        if (cornerIndex === 0) {
            this.path.segments[3].point.y += y;
            this.path.segments[cornerIndex + 1].point.x += x;

            this.circles.children[3].position = this.path.segments[3].point;
            this.circles.children[cornerIndex + 1].position = this.path.segments[cornerIndex + 1].point;
        } else if (cornerIndex === 1) {
            this.path.segments[cornerIndex - 1].point.x += x;
            this.path.segments[cornerIndex + 1].point.y += y;

            this.circles.children[cornerIndex - 1].position = this.path.segments[cornerIndex - 1].point;
            this.circles.children[cornerIndex + 1].position = this.path.segments[cornerIndex + 1].point;
        } else if (cornerIndex === 2) {
            this.path.segments[cornerIndex - 1].point.y += y;
            this.path.segments[cornerIndex + 1].point.x += x;

            this.circles.children[cornerIndex - 1].position = this.path.segments[cornerIndex - 1].point;
            this.circles.children[cornerIndex + 1].position = this.path.segments[cornerIndex + 1].point;
        } else {
            this.path.segments[cornerIndex - 1].point.x += x;
            this.path.segments[0].point.y += y;

            this.circles.children[cornerIndex - 1].position = this.path.segments[cornerIndex - 1].point;
            this.circles.children[0].position = this.path.segments[0].point;
        }

        this.checkContacts();
    }

    checkContacts() {
        if (!this.path.data.contacts) {
            return;
        }

        for (let i = 0; i < this.path.data.contacts.length; i++) {
            let contact = this.path.data.contacts[i];
            let curve = this.path.curves[contact.curveIndex];
            let point = curve.getLocationAtTime(contact.curveTime).point;

            for (let m = 0; m < this.layer.connections.length; m++) {
                let connection = this.layer.connections[m];
                if (connection.path.data.uuid === contact.connectionId) {
                    let snappedSegment;
                    if (contact.connectionSegmentPosition === 'first') {
                        snappedSegment = connection.path['firstSegment'];
                    } else if (contact.connectionSegmentPosition === 'last') {
                        snappedSegment = connection.path['lastSegment'];
                    } else {
                        throw 'Trying to keep an unknown or a middle segment snapped';
                    }

                    connection.movePoint(snappedSegment.index, point.x, point.y, true);

                    break;
                }
            }
        }
    }

    onDrag(e) {
        if (this.layer.project.mode !== Project.MODE_DEFAULT) {
            return;
        }

        this.group.position.x += e.delta.x;
        this.group.position.y += e.delta.y;

        this.checkContacts();
    }

    onDown() {
        if (this.layer.project.mode !== Project.MODE_DEFAULT) {
            return;
        }

        this.originalIndex = this.group.index;
        this.group.bringToFront();
    }

    onUp() {
        if (this.layer.project.mode !== Project.MODE_DEFAULT) {
            return;
        }

        this.group.parent.insertChild(this.originalIndex, this.group);
    }

    onCircleDrag(e) {
        e.stopPropagation();

        this.moveCorner(e.target.index, e.delta.x, e.delta.y);
    }

    hide() {
        this.group.visible = false;
    }

    show() {
        this.group.visible = true;
    }

    toSerializable() {
        return JSON.parse(this.group.exportJSON());
    }

    destroy() {
        this.group.remove();
    }

    setSize(size) {
        this.moveCorner(0, size[0], size[1]);
    }
}
